import type { FunctionComponent } from 'react';

import type { SourceType } from '@trello/analytics-types';

import { CopyCardTabBoard } from './CopyCardTabBoard';
import { CopyCardTabInbox } from './CopyCardTabInbox';
import { CopyMoveCardTabs } from './CopyMoveCardTabs';

export interface CopyCardPopoverProps {
  onClose: () => void;
  source?: SourceType;
}

export const CopyCardPopover: FunctionComponent<CopyCardPopoverProps> = ({
  onClose,
  source,
}) => {
  return (
    <CopyMoveCardTabs
      generateBoardTab={() => (
        <CopyCardTabBoard onClose={onClose} source={source} />
      )}
      generateInboxTab={() => (
        <CopyCardTabInbox onClose={onClose} source={source} />
      )}
    />
  );
};
